import { Action, createReducer, on } from "@ngrx/store";
import { SocialState, SOCIAL_STATE_INIT, SOCIAL_VIDEOS_INIT } from "./social.state";
import * as socialActions from "./social.actions";

const _socialReducer = createReducer(

    SOCIAL_STATE_INIT,

    on(
        socialActions.loadSocialData,
        (state, _) => {
            return {
                ...SOCIAL_STATE_INIT,
                loading: true
            }
        }
    ),

    on(
        socialActions.socialDataLoaded,
        (state, action) => {
            return {
                ...state,
                loading: false,
                error: null,
                videos: action.videos,
                accounts: action.accounts,
                podcasts: action.podcasts,
                posts: action.posts
            }
        }
    ),

    on(
        socialActions.loadSocialError,
        (state, action) => {
            return {
                ...state,
                loading: false,
                error: action.errorMessage ? action.errorMessage : 'Unknown error'
            }
        }
    ),
);

export function socialReducer(state: SocialState, action: Action) {
    return _socialReducer(state, action);
}